export const dataSeo = { 
	vagaDetalhes: {
    seo: {
      title: 'Reachr, a plataforma de recrutamento inteligente - Detalhes da vaga',
      metaTags: [
        { name: 'title', content: 'Reachr, a plataforma de recrutamento inteligente - Detalhes da vaga' },
        { name: 'description', content: 'Inteligência é ganhar rapidez e eficiência no dia a dia. A Reachr atua em 3 pilares: atração, seleção e gestão.' },
        { name: 'keywords', content: 'Recrutamento, rh, Recrutamento digital, recurso humanos, vagas' },
        { property: 'og:title', content: 'Reachr, a plataforma de recrutamento inteligente - Detalhes da vaga' },
        { property: 'og:description', content: 'Inteligência é ganhar rapidez e eficiência no dia a dia. A Reachr atua em 3 pilares: atração, seleção e gestão.' },
        { property: 'og:url', content: 'https://www.reachr.com.br/vaga'},
        { property: 'og:image', content: 'https://www.reachr.com.br/vaga/assets/img/compatilhar-vaga.png'},
        { property: 'og:image:type', content: 'image/png'},
        { property: 'og:image:width', content: '1200'},
        { property: 'og:image:height', content: '670'},
        { name: 'twitter:title', content: 'Reachr, a plataforma de recrutamento inteligente - Detalhes da vaga' },
        { name: 'twitter:description', content: 'Inteligência é ganhar rapidez e eficiência no dia a dia. A Reachr atua em 3 pilares: atração, seleção e gestão.' },
      ]
    }
  },
	paginaNaoEncontrada: {
    seo: {
      title: 'Reachr, a plataforma de recrutamento inteligente - Página não encontrada',
      metaTags: [
        { name: 'title', content: 'Reachr, a plataforma de recrutamento inteligente - Página não encontrada' },
        { name: 'description', content: 'Intelig&ecirc;ncia &eacute; ganhar rapidez e efici&ecirc;ncia no dia a dia. A Reachr atua em 3 pilares: atra&ccedil;&atilde;o, sele&ccedil;&atilde;o e gest&ccedil;&atilde;.' },
        { name: 'keywords', content: 'Recrutamento, rh, Recrutamento digital, recurso humanos, vagas' },
        { property: 'og:title', content: 'Reachr, a plataforma de recrutamento inteligente - Página não encontrada' },
        { property: 'og:description', content: 'Intelig&ecirc;ncia &eacute; ganhar rapidez e efici&ecirc;ncia no dia a dia. A Reachr atua em 3 pilares: atra&ccedil;&atilde;o, sele&ccedil;&atilde;o e gest&ccedil;&atilde;.' },
        { property: 'og:url', content: "https://www.reachr.com.br" },
        { property: 'og:image', content: 'https://www.reachr.com.br/vaga/assets/img/compatilhar-vaga.png'},
        { property: 'og:image:type', content: 'image/png'},
        { property: 'og:image:width', content: '1200'},
        { property: 'og:image:height', content: '670'},
        { name: 'twitter:title', content: 'Reachr, a plataforma de recrutamento inteligente - Página não encontrada' },
        { name: 'twitter:description', content: 'Intelig&ecirc;ncia &eacute; ganhar rapidez e efici&ecirc;ncia no dia a dia. A Reachr atua em 3 pilares: atra&ccedil;&atilde;o, sele&ccedil;&atilde;o e gest&ccedil;&atilde;.' },
      ]
    }
  },
	vagaNaoEncontrada: {
    seo: {
      title: 'Reachr, a plataforma de recrutamento inteligente - Vaga não encontrada',
      metaTags: [
        { name: 'title', content: 'Reachr, a plataforma de recrutamento inteligente - Vaga não encontrada' },
        { name: 'description', content: 'Intelig&ecirc;ncia &eacute; ganhar rapidez e efici&ecirc;ncia no dia a dia. A Reachr atua em 3 pilares: atra&ccedil;&atilde;o, sele&ccedil;&atilde;o e gest&ccedil;&atilde;.' },
        { name: 'keywords', content: 'Recrutamento, rh, Recrutamento digital, recurso humanos, vagas' },
        { property: 'og:title', content: 'Reachr, a plataforma de recrutamento inteligente - Vaga não encontrada' },
        { property: 'og:description', content: 'Intelig&ecirc;ncia &eacute; ganhar rapidez e efici&ecirc;ncia no dia a dia. A Reachr atua em 3 pilares: atra&ccedil;&atilde;o, sele&ccedil;&atilde;o e gest&ccedil;&atilde;.' },
        { property: 'og:url', content: "https://www.reachr.com.br/vaga-nao-encontrada"},
        { property: 'og:image', content: 'https://www.reachr.com.br/vaga/assets/img/compatilhar-vaga.png'},
        { property: 'og:image:type', content: 'image/png'},
        { property: 'og:image:width', content: '1200'},
        { property: 'og:image:height', content: '670'},
        { name: 'twitter:title', content: 'Reachr, a plataforma de recrutamento inteligente - Vaga não encontrada' },
        { name: 'twitter:description', content: 'Intelig&ecirc;ncia &eacute; ganhar rapidez e efici&ecirc;ncia no dia a dia. A Reachr atua em 3 pilares: atra&ccedil;&atilde;o, sele&ccedil;&atilde;o e gest&ccedil;&atilde;.' },
      ]
    }
  }
}